import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/** Family Room (Phase 13A) - see rules/family-room.ts for the matching calculator. */
export const familyRoomQuestions: QuestionDefinition[] = [
  flooringQuestion("family_room", 200, "family room"),
  paintingQuestion("family_room", 210),
  trimQuestion("family_room", 220),
  lightingQuestion("family_room", 230),
  builtInsQuestion("family_room", 240, "What about a built-in media wall or entertainment cabinetry?", "Custom media wall"),
  windowsDoorsQuestion("family_room", 250, "Any window or door changes?"),
  booleanQuestion("family_room_wet_bar", "family_room", "Adding a wet bar?", 260)
];
